import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class FeaturelistService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);

   }

   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }

   // Create FeatureLists
   createFeatureLists(user: Object): Observable<Object> {
    console.log("In createfeatureLists method, featureLists: ", user);
    return this.http.post(`${environment.apiUrl}/featureLists`, user).pipe(catchError(this.handleError));
  }

    // Get FeatureLists by Id Get
    getFeatureLists(id: number): Observable<Object> {
      return this.http.get(`${environment.apiUrl}/featureLists/${id}`).pipe(catchError(this.handleError));
    }

     //Delete FeatureLists by Id Delete
    deleteFeatureLists(id: number): Observable<Object> {
      return this.http.delete(`${environment.apiUrl}/featureLists/${id}`).pipe(catchError(this.handleError));
    }

    //Update FeatureLists by Id Put
    updateFeatureLists(user: Object,id: number): Observable<Object> {
      console.log("In createUser method, user: ", user);
      return this.http.put(`${environment.apiUrl}/featureLists/${id}`, user).pipe(catchError(this.handleError));
    }

    //Get All FeatureLists by Id Get
    getAllFeatureLists(): Observable<Object> {
     return this.http.get(`${environment.apiUrl}/featureLists`).pipe(catchError(this.handleError));
    }

}
